/* eslint-disable */
jQuery(document).ready(function ($) {
    $('.sitemap__content__group').each(function( index ) {
        let groups = $(this).find('.sitemap__content__group--urls');
        $(this).find('.sitemap__content__group--title').attr('data-content', groups.find('li').length);
    });

    let icon = $('<span class="sitemap-icon"></span>');
    $( ".sitemap__content__group--urls .page_item" ).prepend(icon);
    $("a.anchor__menu__items__type").click(function(event) {
        event.preventDefault();
        $("html, body").animate({
            scrollTop: $($(this).attr("href")).offset().top - 100
          }, 2000);
      });
});